export default __webpack_public_path__ + "fc1b61a7c331b2262681a05858922851.png";